'use memo'

import React from 'react'
import { AlertOutlined } from '@ant-design/icons'
import { ScrollSpyLayout } from 'src/components/ScrollSpyLayout'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { TextField, PhoneField, FieldRow } from '../FormikField'

const EmergencyContactSection: React.FC = () => (
  <ScrollSpyLayout.Section
    id='emergencyContact'
    title={capitalizeWords('Emergency Contact')}
    icon={<AlertOutlined />}
  >
    <FieldRow>
      <TextField
        name='emergencyContactName'
        label='Emergency Contact Name'
        placeholder={capitalizeWords('Full name')}
      />
      <TextField
        name='emergencyContactRelationship'
        label='Emergency Contact Relationship'
        placeholder='e.g. Mother'
      />
    </FieldRow>
    <FieldRow>
      <PhoneField
        name='emergencyContactPhone'
        label='Emergency Contact Phone Number'
      />
    </FieldRow>
  </ScrollSpyLayout.Section>
)

export default EmergencyContactSection
